import { Navigate, RouteObject, useLocation } from 'react-router-dom';

import config from '../../../config';

/**
 * Product preview lives in the Health page's "Product preview" tab. The old standalone route redirects
 * there, keeping any query string (tenantId, businessId, sku) so shared links still reproduce the lookup.
 */
const ProductPreviewRedirect = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('tab', 'product-preview');
  return <Navigate to={`/health?${params.toString()}`} replace />;
};

// Only where the System page itself is routed (env config systemPage).
const ProductPreviewRoutes: RouteObject[] = config.systemPage
  ? [
      {
        path: 'system/product-preview',
        element: <ProductPreviewRedirect />,
      },
    ]
  : [];

export default ProductPreviewRoutes;
